<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { type TTexts } from '@/types'
import { Timeline } from 'primevue'
import { computed } from 'vue'
const props = defineProps<{ texts: TTexts }>()

const timelineItems = computed(() => {
  return [
    {
      title: props.texts.tl1title,
      location: props.texts.tl1location,
      time: props.texts.tl1time,
      locationLink: props.texts.tl1locationLink,
    },
    {
      title: props.texts.tl2title,
      location: props.texts.tl2location,
      time: props.texts.tl2time,
      locationLink: props.texts.tl2locationLink,
    },
    {
      title: props.texts.tl3title,
      time: props.texts.tl3time,
    },
    {
      title: props.texts.tl4title,
      time: props.texts.tl4time,
    },
  ]
})
</script>

<template>
  <div class="container bg-tertiary">
    <Timeline :value="timelineItems" class="timeline" :style="{ width: '100%' }" align="alternate">
      <template #content="{ item }">
        <div class="timeline-item-content text">
          <div>{{ item.time }}</div>
          <div>{{ item.title }}</div>
          <div>
            <a :href="item.locationLink" target="_blank" v-if="item.locationLink">
              {{ item.location }} <i class="pi pi-external-link" style="font-size: 0.8rem"></i>
            </a>
          </div>
        </div>
      </template>
    </Timeline>
  </div>
</template>

<style scoped lang="scss">
.container {
  width: 100%;
  // max-width: 520px;
  margin: 0 auto 24px auto;
  padding: var(--default-space);
  box-sizing: border-box;
  overflow-x: auto;
}

@media (max-width: $breakpoint-tablet) {
  .container {
    // max-width: 100vw;
    padding-left: 8px;
    padding-right: 8px;
  }
}
</style>
